import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { Modal } from 'antd';
import styled, { css } from 'styled-components';

export const StyledModal = styled(Modal)<{
  isNoHorizontalPadding?: boolean;
  minHeight?: string;
  noPaddingBody?: boolean;
  titleFullWidth?: boolean;
}>`
  .ant-modal-content {
    min-height: ${({ minHeight }) => minHeight || '760px'};
    display: flex;
    flex-direction: column;
    padding: 0;
    border-radius: 8px;
    .ant-modal-close {
      color: ${({ theme }) => theme.palette.text.primary};
      &:hover {
        background-color: inherit;
        color: ${({ theme }) => theme.palette.text.secondary};
      }
    }
  }
  .ant-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 19px 24px;
    margin-bottom: 0;
    border-bottom: 1px solid ${({ theme }) => theme.divider};
    .ant-modal-title {
      color: ${defaultTheme.theme.palette.text.primary};
      font-size: 18px;
      line-height: 26px;
      display: flex;
      align-items: center;
      gap: 8px;
      ${({ titleFullWidth = false }) =>
        titleFullWidth &&
        css`
          width: 100%;
          padding-right: 40px;
        `}
    }
  }
  .ant-modal-body {
    padding: ${({ isNoHorizontalPadding = false, noPaddingBody = false }) =>
      noPaddingBody ? '0' : isNoHorizontalPadding ? '19px 0' : '19px 24px'};
  }
  .ant-modal-footer {
    margin-top: auto;
    padding: 16px 24px;
    border-top: 1px solid ${({ theme }) => theme.divider};
  }
`;
